import { h } from "preact";
import { useEffect } from "preact/hooks";

import { Keyboard } from "../../../../foundation/enums";
import classname from "../../../../foundation/utils/classname";
import { cmdKey } from "../../../../foundation/utils/keyboard";
import { getCmdKeyShortcut } from "../../../../foundation/utils/shortcut";
import IconSearch from "../../Icons/IconSearch";
import Button, { ButtonVariant } from "../../Button";

import styles from "./GlobalSearchButton.module.css";

interface Props {
    class?: string;
    popupOpen?: boolean;
    onClick?: (ev: Event) => void;
    onOpenPopup?: () => void;
    onClosePopup?: () => void;
}

function GlobalSearchButton({
    class: cssClass,
    popupOpen,
    onClick,
    onOpenPopup,
    onClosePopup
}: Props) {
    useEffect(() => {
        function handleKeyDown(ev: KeyboardEvent) {
            if (popupOpen && ev.key === Keyboard.Key.Escape) {
                ev.stopPropagation();
                ev.preventDefault();
                onClosePopup?.();
            } else if (!popupOpen && cmdKey(ev) && (ev.key === Keyboard.Key.j || ev.key === Keyboard.Key.k)) {
                ev.preventDefault();
                onOpenPopup?.();
            }
        }

        document.addEventListener("keydown", handleKeyDown, true);

        return () => {
            document.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [popupOpen, onOpenPopup, onClosePopup]);

    return (
        <Button
            class={classname(styles.globalSearchButton, "noSelect", cssClass)}
            textClass="body-1"
            variant={ButtonVariant.Secondary}
            icon={IconSearch}
            onClick={onClick}>
            <span class={styles.content}>
                <span class={classname(styles.text, "ellipsis")}>Search workspace</span>
                <span class={styles.shortcut}>{getCmdKeyShortcut("K")}</span>
            </span>
        </Button>
    );
}

export default GlobalSearchButton;
